import React from "react";
import Card from "@components/cards/Card/Card";
import Button from "@components/buttons/Button/Button";
import styles from "@styles/CommonAuthPageLayout.module.css";
import CheckIcon from "@components/display/CheckIcon/CheckIcon";

const ResetConfirmationPage = () => {
    return (
        <div>
            <Card className={styles.cardContainer}>
                <div className={styles.linkContainer}>
                    <CheckIcon />
                    <p>Password successfully reset.</p>
                </div>
                <div className={styles.buttonLinkContainer}>
                    <Button
                        variant="primary"
                        to="/auth/sign-in"
                    >
                        Sign In
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default ResetConfirmationPage;
